import { SearchCondition } from 'src/app/shared/model/search-condition.model';
import { AutoSearchConditionGroup } from 'src/app/shared/model/auto-search-condition-group.model';
import { OnInit, OnDestroy } from '@angular/core';
import { ClickEventService } from 'src/app/shared/service/click-event.service';
import { Subscription, forkJoin } from 'rxjs';
import { Router } from '@angular/router';
import { SearchAutoService } from 'src/app/shared/service/search/search-auto.service';
import { environment } from 'src/environments/environment';
import { PageEnums } from 'src/app/shared/enum/page-enums';
import { PairSuitabilityFeedbackService } from 'src/app/shared/service/pair-suitability-feedback.service';
import { SearchConditionService } from 'src/app/shared/service/search-condition.service';
var MatchingAutoComponent = /** @class */ (function () {
    function MatchingAutoComponent(pairSuitabilityFeedbackService, router, searchAutoService, clickEventService, searchConditionService) {
        this.pairSuitabilityFeedbackService = pairSuitabilityFeedbackService;
        this.router = router;
        this.searchAutoService = searchAutoService;
        this.clickEventService = clickEventService;
        this.searchConditionService = searchConditionService;
        this.closeSearch = false;
        this.openCard = [];
        this.results = [];
        // 読み込み済み判定フラグ。フラグ使わない方が可読性がいいけど、resultsを複数回上書いているのでとりあえず。
        this.alreadyRead = false;
        this.searchParamsAuto = new SearchCondition({
            active_tab_id: 'new-matching-auto',
            mail_type: 'new-matching-auto'
        });
        this.searchParamsWorker = new SearchCondition({
            active_tab_id: 'ngb-tab-1',
            mail_type: 'ngb-tab-1'
        });
        this.searchParamsProject = new SearchCondition({
            active_tab_id: 'ngb-tab-0',
            mail_type: 'ngb-tab-0'
        });
        this.searchParams = this.searchAutoService.getAutoSearchConditionGroup() ||
            new AutoSearchConditionGroup({
                auto: this.searchParamsAuto,
                worker: this.searchParamsWorker,
                project: this.searchParamsProject
            });
        this.loading = false;
        this.calcCount = 0;
        this.autoLoadCount = 0; // メール取得処理リクエストの自動作成処理の回数
        this.staging = environment.staging;
        this.activeTabId = this.staging ? 'new-matching-auto' : 'ngb-tab-0';
        this.searchedTabId = 'ngb-tab-0';
        this.page = PageEnums.auto;
        // キーセットページネーション用のパラメータ
        this.lastMatchingScore = null;
        this.lastId = null;
        this.disLikedPair = [];
    }
    MatchingAutoComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.stateSub$ = this.searchAutoService.searchState.subscribe(function (res) {
            if (_this.searchSub$) {
                _this.searchSub$.unsubscribe();
            }
            _this.autoLoadCount = 1;
            _this.calcCount = res.calc_count;
            _this.results = res.results;
            _this.alreadyRead = true;
            // キーセットページネーション用のパラメータを初期化
            _this.lastMatchingScore = res.last_matching_score || null;
            _this.lastId = res.last_id || null;
            _this.pageLoad();
        });
        this.submittedPair$ = this.pairSuitabilityFeedbackService.submittedPair$
            .asObservable()
            .subscribe(function (param) {
            if (!param.suitable) {
                _this.disLikedPair.push([param.ai_worker_id, param.ai_project_id]);
            }
        });
        // ヘッダーのページタブクリックのイベント受信
        this.tabClickState$ = this.clickEventService.autoTabState.subscribe(function (res) {
            if (_this.searchSub$) {
                _this.searchSub$.unsubscribe();
            }
            _this.autoLoadCount = 0;
            _this.alreadyRead = false;
            // キーセットページネーション用のパラメータをリセット
            _this.lastMatchingScore = null;
            _this.lastId = null;
            _this.initialPageLoad();
        });
        // 検索のデフォルト設定を案件/人材並行して取得
        forkJoin([
            this.searchConditionService.getWorkerRule(),
            this.searchConditionService.getProjectRule()
        ]).subscribe(function (_a) {
            var workerRes = _a[0], projectRes = _a[1];
            var workerRule = workerRes.body.default_search_rule;
            var projectRule = projectRes.body.default_search_rule;
            var autoSearchConditionGroup = _this.searchAutoService.getAutoSearchConditionGroup();
            var autoRule = autoSearchConditionGroup ? autoSearchConditionGroup.auto : null;
            _this.searchParamsWorker = workerRule ? new SearchCondition(workerRule) : _this.searchParamsWorker;
            _this.searchParamsProject = projectRule ? new SearchCondition(projectRule) : _this.searchParamsProject;
            _this.searchParamsAuto = autoRule ? new SearchCondition(autoRule) : _this.searchParamsAuto;
            // searchParams の初期化
            _this.searchParams =
                new AutoSearchConditionGroup({
                    auto: _this.searchParamsAuto,
                    worker: _this.searchParamsWorker,
                    project: _this.searchParamsProject
                });
            // 初回ページ読み込み
            _this.initialPageLoad();
        });
    };
    MatchingAutoComponent.prototype.ngOnDestroy = function () {
        if (this.submittedPair$) {
            this.submittedPair$.unsubscribe();
        }
        if (this.stateSub$) {
            this.stateSub$.unsubscribe();
        }
        if (this.searchSub$) {
            this.searchSub$.unsubscribe();
        }
        if (this.tabClickState$) {
            this.tabClickState$.unsubscribe();
        }
    };
    // 初回ページ読み込み
    MatchingAutoComponent.prototype.initialPageLoad = function () {
        var _this = this;
        if (this.searchSub$) {
            this.searchSub$.unsubscribe();
        }
        this.searchAutoService.setSearchCondition(this.searchParams);
        this.searchSub$ = this.searchAutoService.search().subscribe(function (res) {
            _this.searchAutoService.searchSubject.next(res.body);
        });
    };
    MatchingAutoComponent.prototype.clickCard = function (i) {
        return (this.openCard[i] = this.openCard[i] ? false : true);
    };
    MatchingAutoComponent.prototype.preventClickEvent = function (e) {
        e.stopImmediatePropagation();
        e.preventDefault();
    };
    MatchingAutoComponent.prototype.loadingStart = function () {
        this.alreadyRead = false;
    };
    MatchingAutoComponent.prototype.loadingFinish = function () {
        this.alreadyRead = true;
        this.openCard = [];
    };
    MatchingAutoComponent.prototype.onDeleted = function (i, mail_type) {
        // エラー報告されたメールを含めたペアをresultsから削除
        var delete_ai_mail_id = mail_type === 'project'
            ? this.results[i].project_mail.ai_mail_id
            : this.results[i].worker_mail.ai_mail_id;
        this.results = this.results.filter(function (result) {
            return mail_type === 'project'
                ? result.project_mail.ai_mail_id !== delete_ai_mail_id
                : result.worker_mail.ai_mail_id !== delete_ai_mail_id;
        });
    };
    MatchingAutoComponent.prototype.pageLoad = function () {
        var _this = this;
        this.loading = true;
        var project_ai_mail_ids = [];
        var worker_ai_mail_ids = [];
        this.results.forEach(function (result) {
            project_ai_mail_ids.push(result.project_mail.ai_mail_id);
            worker_ai_mail_ids.push(result.worker_mail.ai_mail_id);
        });
        // last_matching_scoreとlast_idをパラメータに追加
        var params = {
            project_ai_mail_ids: project_ai_mail_ids,
            worker_ai_mail_ids: worker_ai_mail_ids,
            calc_count: this.calcCount,
            last_matching_score: this.lastMatchingScore,
            last_id: this.lastId
        };
        if (this.searchSub$) {
            this.searchSub$.unsubscribe();
        }
        this.searchSub$ = this.searchAutoService
            .search('', params)
            .subscribe(function (res) {
            _this.loading = false;
            _this.results = _this.results.concat(res.body.results);
            _this.calcCount = res.body.calc_count;
            // last_matching_scoreとlast_idを保存
            _this.lastMatchingScore = res.body.last_matching_score;
            _this.lastId = res.body.last_id;
            console.log('API Response:', {
                results: res.body.results.length,
                calcCount: res.body.calc_count,
                lastMatchingScore: res.body.last_matching_score,
                lastId: res.body.last_id
            });
            // 結果が0件の場合、さらに検索を試みる
            if (res.body.results.length === 0 && _this.autoLoadCount < 5) {
                _this.autoLoad();
            }
        });
    };
    // メールペア数が６件以下、且つおすすめ一覧ページに存在する時だけ、メール取得処理の作成
    // おすすめ一覧ページから移動した時に処理を終了するため
    MatchingAutoComponent.prototype.autoLoad = function () {
        if (this.autoLoadCount < 5) {
            if (this.router.url.indexOf('auto') !== -1) {
                this.autoLoadCount += 1;
                this.pageLoad();
            }
        }
        else {
            this.autoLoadCount = 0;
        }
    };
    MatchingAutoComponent.prototype.getKeys = function (keyWordsObject) {
        var baseKeywords = [];
        if (keyWordsObject) {
            for (var _i = 0, _a = Object.entries(keyWordsObject); _i < _a.length; _i++) {
                var _b = _a[_i], key = _b[0], value = _b[1];
                if (value > 1) {
                    baseKeywords.push(key);
                }
            }
        }
        return baseKeywords;
        // return keyWordsObject ? Object.keys(keyWordsObject) : [];
    };
    MatchingAutoComponent.prototype.IsDislikePair = function (worker_id, project_id) {
        var findPair = this.disLikedPair.find(function (pair) { return pair[0] === worker_id && pair[1] === project_id; });
        return !!findPair ? 'true' : 'false';
    };
    MatchingAutoComponent.prototype.dislikeDoneEvent = function (worker_id, project_id, openCardId, event) {
        if (event.fromState === 'false' && event.toState === 'true') {
            console.log('fff');
            this.disLikedPair = this.disLikedPair.filter(function (pair) { return pair[0] !== worker_id || pair[1] !== project_id; });
        }
    };
    return MatchingAutoComponent;
}());
export { MatchingAutoComponent };
